"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_TOOLTIP_DATA = exports.DEFAULT_ICON = exports.BREAKPOINTS = void 0;
var DEFAULT_ICON = {
  color: 'greyDark',
  fontsize: 'titleSmall',
  type: 'InfoIcon'
};
exports.DEFAULT_ICON = DEFAULT_ICON;
var DEFAULT_TOOLTIP_DATA = {
  width: 200,
  zIndex: 1000
};
exports.DEFAULT_TOOLTIP_DATA = DEFAULT_TOOLTIP_DATA;
var BREAKPOINTS = {
  SMALL_MOBILE: '320px',
  MOBILE: '599px',
  SMALL_TABLET: '600px',
  MEDIUM_TABLET: '720px',
  LARGE_TABLET: '840px',
  DESKTOP: '1280px'
};
exports.BREAKPOINTS = BREAKPOINTS;